import { DiscountTypeEnum } from 'src/app/enum/discount-type.enum';

export class Ean {
  quantity: number;
  additionnalQuantity: number;
  additionnalQuantityUnit: string;
  nameFr?: string;
  nameEn?: string;
  categoryNameFr: string;
  categoryNameEn: string;
  additionalInfo: string;
  additionalInfoQuotation: string;
  description?: string;
  note?: string;
  eanId?: string;
  pv?: number;
  realPV?: number;
  realPVDiscount?: {
    discountPrices?: DiscountPrices;
    amount: number;
  };
}

type DiscountPrices = {
  [key in DiscountTypeEnum]: {
    amountDiscount: number;
    amount: number;
  };
};
